import CrmItemApi from "./CrmItem";

export default CrmItemApi;